import { SessionLockStatusQuery } from '@/lib/types/session';
import { BookingGateway } from '@/services/http/booking-gateway';
import { sessionIdService } from '@/services/session-id/session-id.service';
import { useQuery } from '@tanstack/react-query';

const useSessionLockStatus = () => {
  const URL = '/public/session/lock-status';
  const sessionId = sessionIdService.get();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['session-lock-status', sessionId],
    queryFn: async () => {
      const response = await BookingGateway.get<SessionLockStatusQuery>(URL);
      return response;
    },
    enabled: !!sessionId.length,
    staleTime: Infinity,
  });

  return {
    isLocked: data?.result.is_locked,
    isLoading,
    isError,
    error,
  };
};

export { useSessionLockStatus };
